import React, {useEffect} from 'react';
import styled from "styled-components";
import {Link} from "react-router-dom";
import {HelmetProvider, Helmet} from 'react-helmet-async'
import FontTest from "../components/FontTest";
import Button from "../components/Button";

const MyComponent = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>components</title>
                <meta name="description" content="Description"/>
            </Helmet>

            <StyledComponent className={'pt-100'}>
                <FontTest/>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`

`;

export default MyComponent;
